module.exports = __webpack_public_path__ + "img/step35_b_printer_power_fix_printer_left_side - Copy.68fb2fde.png";